
















































































































import store from '@/store';
import { homeStoreActions } from '@/pages/home/store';
import { IS_PRERENDERING } from '@hb/coffee-prerender';
import {
  defineComponent, onMounted, ref, computed, onBeforeUnmount,
  onActivated,
} from '@vue/composition-api';
import { setIosBouncesEable } from '@/api/native';
import HomeBottomBar from '@/components/home-bottom-bar';
import { ubtSendError } from '@/shared/utils/ubt';
import AdvProductList from '@/components/adv-components/adv-product-list';
import { useUserAuth } from '@/hooks/useUserAuth';
import { dispatchActions } from '@/store/dispatchActions';
import { agreementService } from '@/service/confirm-agreements';
import { identityScoreService } from '@/service/confirm-identity-score';
import { NormalPreCreditModelEnums, PreCreditUserSourceEnums } from '@/enums/home-type';
import RouterHelper from '@/shared/utils/routerHelper';
import { removeContainerLoading } from '@/api/native/container';
import { PageSourceEnum, PageSceneEnum } from '@/api/common/types';
import { RouterV2Enum } from '@/router/router-names';
import { initActivityModulesConfig, ActivityPageTypeEnums } from '@/shared/activity-undertake';
import { HomeDailogTypeEnum, MiddleIncomeData } from './types';
import { getHomeCustomConfig, getSceneTypeMapping } from './config';
import NavBar from './components/NavBar/index.vue';
import AtmosphericHeader from './components/AtmosphericHeader/index.vue';
import FinanceNormalCard from './components/FinanceCard/FinanceNormalCard/index.vue';
import AdvantageList from './components/AdvantageList/index.vue';
import NewcomerGuide from './components/NewcomerGuide/index.vue';
import DailogController, { DailogControllerRef } from './components/DailogController/index.vue';
import MessageNoticeBar from './components/MessageNoticeBar/index.vue';
import PocketMoneyCard from './components/PocketMoneyCard/index.vue';
import CreditSupplementary from './components/CreditSupplementary/index.vue';
/** 改为同步调用 */
import MiddleIncome from './components/MiddleIncome/index.vue';
import {
  getEquityRecallData, getIncreaseCreditInfo, assignAsync,
  getMarketBannerAdv,
  getMiddleIncome,
} from './service';
import type { CallbackType, IncreaseCreditInfoType } from './service';
import { homeListerBack, refreshComponentInstanceKey } from './utils';

/**
 * 异步加载费非首屏展示的组件：
 * 关于我们、提额专区、新人引导、风险声明、底部导航栏
 */
import {
  KnowFinancePanel,
  AdvBanners,
  IncreaseCreditZone,
  RiskStatement,
  UserCenterFloat,
  AdvHomeFloat,
  TxxyBanner,
} from './async-loader';
import { OLD_HOME_ROUTE_PATHS } from './constant';

// 快速提现卡片组件 - 异步导入
const QuickWithdrawCard = () => import(
  /* webpackChunkName: "quick-withdraw-card" */'@/components/quick-withdraw-card/index.vue'
);

export default defineComponent({
  name: 'HomePageV3Component',
  components: {
    NavBar,
    AtmosphericHeader,
    FinanceNormalCard,
    AdvantageList,
    HomeBottomBar,
    DailogController,
    AdvProductList,
    NewcomerGuide,
    CreditSupplementary,
    MessageNoticeBar,
    PocketMoneyCard,
    QuickWithdrawCard,
    IncreaseCreditZone,
    AdvBanners,
    KnowFinancePanel,
    RiskStatement,
    UserCenterFloat,
    AdvHomeFloat,
    TxxyBanner,
    MiddleIncome,
  },
  setup() {
    const pageThemeType = computed(() => store.state.base.pageThemeType);
    /** 权益召回 Data */
    const equityRecallInfo = ref<CallbackType>();
    /** 提额降息专区 Data */
    const increaseCreditInfo = ref<IncreaseCreditInfoType | null>(null);
    /** 中收首页 Data */
    const middleIncomeData = ref<MiddleIncomeData>();

    /** 用户授信状态数据 */
    const userCreditData = computed(
      () => store.state.home.creditData || store.state.homeStore.userCreditData,
    );
    /** 海消联合品牌展示状态数据 */
    const haiXiaoQueryData = computed(() => store.state.homeStore.haiXiaoQueryData);
    /** 是否授信中 && 挂起状态 */
    const hasHangAndProgressingTask = computed(
      () => !!store.state.userCreditStatus.isHangAndProgressingTask,
    );
    /** 信贷业务-公共信息 */
    const businessInfoExtra = computed(() => store.state.base.businessInfoExtra);
    /** 金融卡片-营销banner广告位数据 */
    const marketBannerAdv = ref();
    /** 是否命中-上滑查看品质首页的组件ab实验 */
    const newUserShowCreditedComp = computed(() => store.state.home.canSlidInQuality);
    /** 是否是零用钱用户 */
    // eslint-disable-next-line max-len
    const isPocketMoneyLoan = computed(() => userCreditData.value?.normalPreCreditModel === NormalPreCreditModelEnums.POCKET_MONEY_LOAN);

    /** 1.未授信：是否海消用户(海消用户、普通用户)
     *  2.已授信：接口返回海消联合品牌展示状态
     */
    const isHaiXiaoUser = computed(() => (userCreditData.value?.preCreditUserSource
    && [PreCreditUserSourceEnums.SEA_CONSUMER, PreCreditUserSourceEnums.NORMAL]
      .includes(userCreditData.value?.preCreditUserSource))
      || haiXiaoQueryData.value?.showHaiXiaoBrand);
    /** 是否展示中收入口（中收变现人群或商城有额度），中收接口返回数据列表不为空，则认为命中中收场景 */
    // eslint-disable-next-line max-len
    const isMiddleIncomeShow = computed(() => !!middleIncomeData.value?.includeBusiness?.length);
    /** 首页主题、模块配置 */
    const homeCustomConfig = computed(
      () => getHomeCustomConfig(
        store.state.base.pageThemeType,
        getSceneTypeMapping(isPocketMoneyLoan.value, isMiddleIncomeShow.value),
        store.state.base.isSupportWebp,
      ),
    );
    /** 首页模块配置 */
    const moduleConfig = computed(() => homeCustomConfig.value.moduleConfig || {});
    /** 已授信额度用户标识，预授信用户非真实授信额度 */
    const hasCreditedUser = computed(
      () => userCreditData.value?.creditStatus && !userCreditData.value?.preCredit,
    );
    /** 是否展示品牌化文案 */
    const showBrandingExp = computed(() => store.state.homeStore.showBrandingExp);
    // const showBrandingExp = true;
    /** 首页弹窗控制组件实例 */
    const dailogControllerRef = ref<DailogControllerRef>();
    /** 快速提现卡片组件实例 */
    const quickWithdrawCardRef = ref<any>();
    /** 静态组件（如：RiskStatement、KnowFinancePanel）是否可以加载了，避免组件元素闪烁 */
    const staticComponentLoadAble = ref(false);
    /**
     * 页面加载完时，弹窗类型展示
     * 先check天降红包是否有命中，若命中则展示天降红包，否则展示请求开屏广告位弹窗进行展示
     */
    const pageLoadedDailogType = computed(() => {
      if (store.state.base.existTianjiang) {
        return HomeDailogTypeEnum.TIAN_JIANG_MARKET;
      }
      return HomeDailogTypeEnum.PAGE_LOADED_POPUP;
    });
    /** 组件通用静态属性 */
    const commonProps = {
      currentPage: 'newHomePage',
    };
    /** 首页底部导航栏组件实例key */
    const homeBottomBarComponentKey = ref('');
    /** 路由是否激活状态，用于控制弹窗组件在路由切换时隐藏 */
    const isRouteActive = ref(true);
    // 移除快速提现卡片显示状态，组件内部通过 quickLoan 字段控制显示
    const { checkIsLogoutUser } = useUserAuth();

    /** 设置ios弹性滚动禁止 */
    setIosBouncesEable(false);

    /**
     * 刷新首页数据(back返回场景)
     */
    const refetchPageData = async () => {
      try {
        /** 核心内容的刷新，尽量节奏保持一致，减少渲染的抖动 */
        await Promise.allSettled([
          assignAsync(equityRecallInfo, getEquityRecallData()), // 查询权益召回信息
          assignAsync(increaseCreditInfo, getIncreaseCreditInfo()), // 查询提额专区信息
          assignAsync(middleIncomeData, getMiddleIncome()), // 查询中收首页数据
          store.dispatch('home/getCreditData'),
          dispatchActions.userAutarkyStatus.getUserAutarkyState(),
          dispatchActions.base.getBusinessInfoExtra({ pageSource: PageSourceEnum.HOME }),
          // 获取海消联合品牌展示状态
          homeStoreActions.getHaiXiaoQueryStatusResult(PageSceneEnum.HOME),
          // store.dispatch('homeMarketStore/queryHomeInstallMallSummary'), // 商城接口先不调用
        ]);

        /** 静默轮询：临额、预授信下发 */
        homeStoreActions.mutliSceneLoopQueryIssued();
        /** 预加载协议数据 */
        agreementService.preloadAgreementsData();
        /** 预加载身份证清晰分检测数据 */
        identityScoreService.preloadIdentityScoreData();
      } catch (error) {
        ubtSendError({
          name: 'home refetchPageData error',
          message: (error as Error)?.message,
        });
      }
    };

    /**
     * 初始化首页数据
     */
    const initPageData = async () => {
      try {
        /**
         * 阻塞主流程的异步任务列表：
         * 1. 如果旧版首页未初始化授信数据(用户未从v2/home首页进入)，则补充 授信数据 + 其他关键数据
         */
        const blockProcessTaskList: Promise<void | boolean>[] = store.state.home.creditData ? [] : [
          homeStoreActions.getUserCreditData(), // 获取用户授信数据
          /** 获取信贷业务通用信息 */
          dispatchActions.base.getBusinessInfoExtra({ pageSource: PageSourceEnum.HOME }),
        ];

        blockProcessTaskList.push(...[
          assignAsync(marketBannerAdv, getMarketBannerAdv()), // 获取金融卡片-营销banner广告位数据
          assignAsync(equityRecallInfo, getEquityRecallData()), // 查询权益召回信息
          assignAsync(increaseCreditInfo, getIncreaseCreditInfo()), // 查询提额专区信息
          assignAsync(middleIncomeData, getMiddleIncome()), // 查询中收首页数据
          dispatchActions.base.getIsWebviewSkNativeContainer(), // 获取是否在数科容器化Webview容器
          initActivityModulesConfig(ActivityPageTypeEnums.HOME), // 初始化首页模块配置
        ]);

        await Promise.allSettled(blockProcessTaskList);

        /** 若是ocr后置用户，则通知服务端拉取二要素、异步拉取ocr照片 */
        if (store.state.base.businessInfoExtra?.userInfo?.ocrAfterLoan) {
          await dispatchActions.base.getSyncUserInfo();
        }
        /** 关闭-容器化原生Loading */
        if (store.state.base.isWebviewSkNativeContainer) {
          removeContainerLoading();
        }
        /** 轮询：临额、预授信下发 */
        homeStoreActions.mutliSceneLoopQueryIssued();
        /** 预加载协议数据 */
        agreementService.preloadAgreementsData();
        /** 预加载身份证清晰分检测数据 */
        identityScoreService.preloadIdentityScoreData();
      } catch (error) {
        ubtSendError({
          name: 'home initPageData error',
          message: (error as Error)?.message,
        });
      } finally {
        staticComponentLoadAble.value = true;
      }
    };
    /** 首页刷新：返回事件 */
    const pageRefreshForListenBack = async (): Promise<void> => {
      if (!checkIsLogoutUser()) {
        await refetchPageData();
      }
    };
    /** 是否可以执行-组件激活回调事件(初始化时，mounted有执行，所以Activated不应该执行) */
    const canActivatedCallback = ref(0);

    onMounted(async () => {
      if (IS_PRERENDERING) {
        document.dispatchEvent(new Event('render-event'));
      } else {
        /** 检测用户状态(已注销用户，无需请求数据)，若正常初始化首页数据 */
        if (!checkIsLogoutUser()) {
          initPageData();
        }
        /** 监听back返回首页，刷新首页数据 */
        homeListerBack(pageRefreshForListenBack);
      }
    });

    onActivated(() => {
      /** 更新组件激活回调执行次数 */
      canActivatedCallback.value += 1;
      /** 恢复弹窗控制组件显示 */
      isRouteActive.value = true;

      if (canActivatedCallback.value > 1) {
        /** 刷新底部tabbar状态 */
        homeBottomBarComponentKey.value = refreshComponentInstanceKey();
        /** 刷新用户状态数据 */
        pageRefreshForListenBack();

        /** 刷新弹窗组件数据 */
        if (dailogControllerRef.value) {
          dailogControllerRef.value.refreshCurrentDailogShow();
        }
      }
    });

    return {
      pageThemeType,
      homeCustomConfig,
      moduleConfig,
      equityRecallInfo,
      userCreditData,
      hasHangAndProgressingTask,
      marketBannerAdv,
      increaseCreditInfo,
      hasCreditedUser,
      newUserShowCreditedComp,
      middleIncomeData,
      commonProps,
      staticComponentLoadAble,
      businessInfoExtra,
      haiXiaoQueryData,

      dailogControllerRef,
      quickWithdrawCardRef,
      pageLoadedDailogType,
      isPocketMoneyLoan,
      isMiddleIncomeShow,
      homeBottomBarComponentKey,
      isRouteActive,
      showBrandingExp,
      isHaiXiaoUser,
    };
  },
  beforeRouteEnter(to: any, from: any, next: any) {
    if (OLD_HOME_ROUTE_PATHS.includes(from.path)) {
      next();
    }

    next();
  },
  /** 拦截用户退出首页的行为，展示挽留弹窗 */
  async beforeRouteLeave(to: any, from: any, next: any) {
    // 检查快速提现卡片弹窗是否显示，如果显示则关闭并拦截路由
    const quickWithdrawCard = this.$refs.quickWithdrawCardRef as {
      closePopup?: () => Promise<boolean>;
    } | undefined;
    if (quickWithdrawCard && typeof quickWithdrawCard.closePopup === 'function') {
      /** 首页的这些路由，才执行检查快速提现卡片弹窗是否显示，如果显示则关闭并拦截路由 */
      if (OLD_HOME_ROUTE_PATHS.includes(to.path as RouterV2Enum)) {
        const hasClosed = await quickWithdrawCard.closePopup();
        if (hasClosed) {
          /** 后面换成RouterHelper.useNextFalse(next); 待验证 多个弹窗拦截的场景  */
        // 如果关闭了弹窗，拦截路由跳转
          RouterHelper.useNextFalse(next);
          return;
        }
      }
    }

    const doLeave = () => {
      // 路由切换时隐藏弹窗控制组件
      this.isRouteActive = false;
      next();
      /** 恢复ios弹性滚动 */
      setIosBouncesEable(true);
    };

    try {
      if (OLD_HOME_ROUTE_PATHS.includes(to.path) && this.dailogControllerRef) {
        /** 退出首页的流程，check挽留弹窗是否展示，若展示则展示弹窗，否则直接退出首页 */
        this.dailogControllerRef.gotoLeavePageWithBackPopup();
        RouterHelper.useNextFalse(next);
      } else {
        doLeave();
      }
    } catch (error) {
      ubtSendError(error as Error);
      doLeave();
    }
  },
});
